import React from "react";
import { array, bool } from "prop-types";

import CustomStoryCard1 from "../../molecules/custom-story-card1";
import CustomStoryCard3 from "../../molecules/custom-story-card3";
import CustomStoryCard8 from "../../molecules/custom-story-card8";

import "./sixStoryMixedDesignMobile.m.css";

const SixStoryMixedDesignMobile = ({ list, isExternalStory }) => {
  if (!(list && list.length)) {
    return null;
  }

  const stories = [...list];

  const firstSetStories = stories.splice(0, 1);
  const secondSetStories = stories.splice(0, 2);
  const thirdSetStories = stories.splice(0, 1);
  const fourthSetStories = stories.splice(0, 2);

  const get1BigStoryView = (storyList) =>
    storyList.map((item, index) => (
      <CustomStoryCard1 key={index} story={item} headerType={2} showSummary={false} isExternalStory={isExternalStory} />
    ));

  const getTwoStoryView = (storyList) => (
    <div styleName="two-story-view">
      {storyList.map((item, index) => (
        <CustomStoryCard8 key={index} story={item} isExternalStory={isExternalStory} />
      ))}
    </div>
  );

  const get1SmallStoryView = (storyList) =>
    storyList.map((item, index) => (
      <CustomStoryCard3
        key={index}
        story={item}
        imageType="image16x9"
        aspectRatio={[16, 9]}
        widths={[110]}
        headerType={4}
        showHeadlineIcon={true}
        isExternalStory={isExternalStory}
      />
    ));

  return (
    <div styleName="wrapper" className="story-mixed">
      {get1BigStoryView(firstSetStories)}
      {secondSetStories.length ? getTwoStoryView(secondSetStories) : null}
      {thirdSetStories.length ? get1SmallStoryView(thirdSetStories) : null}
      {fourthSetStories.length ? getTwoStoryView(fourthSetStories) : null}
    </div>
  );
};

SixStoryMixedDesignMobile.propTypes = {
  list: array.isRequired,
  isExternalStory: bool,
};

export default SixStoryMixedDesignMobile;
